export const LOGIN = "login";
export const REGISTER = "register/register";
export const GET_EMPLOYEE = "register/employee";
export const CHECK_IN = "/attendance/check-in";
export const CHECK_OUT = "/attendance/check-out";
export const EMPLOYEE_REPORT = "/attendance/all";
export const ADMIN_CREATE = "/admin/create"; 
export const ADMIN_LIST = "/admin/list";
export const UPLOAD_EMPLOYEE_DOCUMENTS ="/documents";
export const GET_EMPLOYEE_DOCUMENTS = "/documents";






